import { CollectPaymentMultiModalInstance } from '../../../collect-payment-multi/collect-payment-multi';
import { SelectInvoiceModalCommonProps } from './single-processor-select-invoice-modal';

export const MultiCollectSelectInvoiceModal = ({
  show: booleanOrString,
  onClose,
  onInsert,
  personId,
  selectedMessageTemplate,
}: SelectInvoiceModalCommonProps) => {
  const booleanShow = booleanOrString === 'hidden' ? false : booleanOrString;
  const handleOnClose = () => {
    onClose?.();
  };

  return (
    <>
      <CollectPaymentMultiModalInstance
        modalProps={{
          show: booleanShow,
          onClose: handleOnClose,
          minWidth: 500,
          maxWidth: 600,
        }}
        collectProps={{
          flow: 'insert',
          personId,
          onInvoiceSelected: (invoice) => {
            onInsert?.({
              invoiceId: invoice.id,
              textToPayLink: invoice.links.payment || '',
              template: selectedMessageTemplate,
            });
            handleOnClose();
          },
        }}
      />
    </>
  );
};
